import { AppError } from '@app/errors/AppError'

export const serializeCurrency = (val: string | number) => {
  let tr = String(val).replace(/\s/g, '')
  if (!/^\d+(\.\d{1,})?$/.test(tr)) throw new AppError(`Value ${val} is not a currency`)
  const parts = tr.split('.')
  if (parts.length > 2) throw new AppError(`Value ${val} is not a currency`)
  if (parts[1]) {
    parts[1] = String(parseFloat('0.' + parts[1]))
      .slice(2)
      .padEnd(2, '0')
    if (parts[1] === '00') parts.pop()
  }
  tr = parts.join('.')
  return tr
}
